<template>
	<div class="sk-widget sk-widget-messaging-banner" v-if="showBanner">
		<div>
			<div>
				<div class="messaging-banner-title">{{ bannerTitle }}</div>
				<div class="messaging-banner-body">{{ bannerBody }}</div>
			</div>
			<button
				v-if="bannerCta"
				class="button button-auto button-primary"
				@click="ctaClicked"
			>
				{{ bannerCta }}
			</button>
		</div>
	</div>
</template>

<style scoped>
.sk-widget-messaging-banner {
	background: var(--gR-base-80);
	color: var(--gR-white);
	min-height: 100px;
	margin-top: 30px;
}

.sk-widget-messaging-banner div {
	color: var(--gR-white);
}

.sk-widget-messaging-banner > div {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.messaging-banner-title {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 15px;
}

.messaging-banner-body {
	font-size: 12px;
}

.button,
.button:hover,
.button:focus {
	font-weight: normal;
	font-size: 10px;
	border: none;
	padding: 5px 20px;
	box-shadow: none;
}

@media (max-width: 500px) {
	.sk-widget-messaging-banner > div {
		flex-direction: column;
		align-items: flex-start;
	}

	.button {
		margin-top: 15px;
	}
}
</style>

<script>
import { ResidentialBannerType } from "@/enums/ResidentialBannerType"
import { eventBus, EventBusEvents } from "@/eventBus"
import { NotificationType } from "@/enums/NotificationType"
import momentUtils from "@/moment-utils"
import moment from "moment"
import residentialBannerMixin from "@/mixins/residential-banner-mixin"

export default {
	name: "ResidentialHomeBanner",
	mixins: [residentialBannerMixin],
	computed: {
		showBanner() {
			return this.bannerType != null
		},
		businessName() {
			return this.$store.state.business && this.$store.state.business.name
				? this.$store.state.business.name
				: ""
		},
		bannerTitle() {
			switch (this.bannerType) {
				case ResidentialBannerType.ACTIVATION:
					return `Join the ${this.businessName.toUpperCase()} community!`
				case ResidentialBannerType.FIRST_ORDER:
					return `$${this.firstTimeCoupon.amount} off first order!`
				case ResidentialBannerType.LOYALTY:
					return "Order and earn!"
				case ResidentialBannerType.LOYALTY_COMPLETE:
					return "You've earning this!"
				case ResidentialBannerType.SMS_OPT_IN:
					return "5% Off All Future Orders"
			}
			return ""
		},
		bannerBody() {
			switch (this.bannerType) {
				case ResidentialBannerType.ACTIVATION:
					return `Activate your 2ndKitchen Amenity to gain access to events and savings exclusive to ${this.businessName}!`
				case ResidentialBannerType.FIRST_ORDER: {
					const now = moment()
					const couponEnd = moment.utc(this.firstTimeCoupon.valid_to)
					const daysLeft = momentUtils.daysDiff(couponEnd, now)
					if (daysLeft != undefined) {
						return `Recieve $${this.firstTimeCoupon.amount} off your first order by placing an order within ${daysLeft}`
					} else {
						return ""
					}
				}
				case ResidentialBannerType.LOYALTY:
					return "You’re only 1 order away from receiving your next loyalty discount!"
				case ResidentialBannerType.LOYALTY_COMPLETE: {
					const amount =
						this.loyaltyCampaign.campaign.parameters.coupon_amount
					return `You’ve placed enough orders to earn your loyalty reward! Enjoy $${amount} off your next order.`
				}
				case ResidentialBannerType.SMS_OPT_IN:
					return "Subscribe to receive SMS updates on daily menus and upcoming events!"
			}
			return ""
		},
		bannerCta() {
			switch (this.bannerType) {
				case ResidentialBannerType.ACTIVATION:
					return "JOIN"
				case ResidentialBannerType.SMS_OPT_IN:
					return "SUBSCRIBE"
			}
			return null
		}
	},
	methods: {
		ctaClicked() {
			this.$store.dispatch("sendMixpanelEvent", {
				msg: "Home Banner Clicked",
				data: {
					banner: this.bannerType
				}
			})
			switch (this.bannerType) {
				case ResidentialBannerType.ACTIVATION: {
					eventBus.emit(EventBusEvents.OPEN_VERIFY_FLOW)
					break
				}
				case ResidentialBannerType.SMS_OPT_IN: {
					this.$emit("toggleLoader", true)
					this.$store
						.dispatch("updateUser", {
							smsOptIn: 1
						})
						.then(() => {
							eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
								message:
									"You're now subscribed to daily menu SMS updates!",
								type: NotificationType.SUCCESS
							})
						})
						.catch((e) => {
							this.bugsnag.notify(
								"Failed to opt into SMS updates",
								(event) => {
									event.addMetadata("error", {
										error: e
									})
								}
							)
							eventBus.emit(EventBusEvents.SHOW_NOTIFICATION, {
								message: "An error occurred, please try again.",
								type: NotificationType.ERROR
							})
						})
						.finally(() => {
							this.$emit("toggleLoader", false)
						})
					break
				}
			}
		}
	},
	beforeDestroy: function () {
		this.$emit("toggleLoader", false)
	}
}
</script>